import React from 'react'
import Navbar from '../Components/Navbar'
import Core from '../Components/Core'
import Footer from '../Components/Footer'
import { isMobile } from 'react-device-detect'

const Chairman = () => {
  return (
    <div>

        <Navbar/>

        <section className='bg-white py-lg-8 py-4 px-lg-8'>
            <div className='container'>
                <div className='display-4 fw-semibold text-dark'>
                <i class="bi bi-megaphone text-primary"></i> PTF Chairman Welcome Speech.
                </div>

                <div className='row gy-6 pt-lg-4 pt-2'>
                    <div className='col-lg-5 order-lg-2 mb-4 mb-lg-0'>
                    <div className="text-start text-lg-center">
                        <img 
                        src={`../../assets/images/background/chairman.png`}
                        alt={`Chairman`}
                        className="img-fluid"
                        width={isMobile ? "90%" : "1500px"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    </div>

                    <div className='col-lg-7 order-lg-1'>
                    <div className='fs-4 text-dark text-start mt-lg-2 px-lg-0'>
                        Distinguished members of the Board,<br/>
                        Our Proprietor and Management Team,<br/>
                        Dedicated Staff and Teachers,<br/>
                        Proud Parents and Guardians,<br/>
                        Esteemed Guests,<br/>
                        And most importantly, our beloved Students,
                        <br/><br/>
                        It gives me immense joy and deep gratitude to welcome you all on behalf of the Parents Teachers Forum to this remarkable gathering of the Ebun Heritage Schools family.
                        <br/><br/>
                        Today, as we stand together, we do so not merely as stakeholders in an institution, but as partners in a noble vision — a vision dedicated to moulding lives, shaping destinies, and nurturing greatness.
                        <br/><br/>
                        When one reflects on the journey of Ebun Heritage Schools, one cannot help but appreciate the solid foundation upon which this institution was built. From its humble beginnings to its present stature, the school has remained steadfast in its commitment to providing a nurturing and enriching environment where academic excellence, character development, and holistic growth are not just aspirations, but daily realities.
                    </div> 
                    </div>

                    <div className='col-lg-12 order-lg-3 mt-lg-4 mt-4'>
                        <div className='fs-4 text-dark text-start mt-lg-2 px-lg-0'>
                        At Ebun Heritage Schools, education is not limited to textbooks and examinations. It is a transformative journey. Our mission — to harness the God-given potentials in every child — is both sacred and profound. Every child that walks through these gates carries within them unique gifts, talents, and dreams. It is our collective responsibility — as parents, educators, and leaders — to guide them in discovering their purpose and inspiring them toward excellence.
                            <br/><br/>
                            The school’s dedication to cultivating academic brilliance, moral integrity, and spiritual growth sets it apart. In a world that constantly evolves and presents new challenges, Ebun Heritage Schools continues to create a safe, supportive, and dynamic learning environment where children are not only taught what to think, but how to think; not only how to succeed, but how to lead; not only how to achieve, but how to serve.
                            <br/><br/>
                            As PTF Chairman, I have witnessed firsthand the tireless efforts of our educators and staff. Their passion, commitment, and sacrificial dedication ensure that every child receives mentorship, guidance, and encouragement. They do not merely teach; they inspire. They do not merely instruct; they nurture. And for this, we owe them our sincere appreciation.
                            <br/><br/>
                            Our vision speaks clearly — to prepare confident, responsible, and globally minded leaders who will positively impact their communities and the world at large. This vision resonates deeply with us as parents. We desire not only successful children but children of integrity. We want leaders who honour God, respect humanity, and pursue excellence with discipline and humility.
                            <br/><br/>
                            The corporate values of this institution are equally commendable. To honour God in all that we do is a principle that anchors our moral compass. In a time when values are often compromised, Ebun Heritage Schools remains grounded in faith, integrity, and righteousness.
                            <br/><br/>
                            To help children develop and dream of a glorious future is a noble calling. Dreams are powerful. They shape ambition, drive innovation, and build nations. This school consistently inspires its students to see beyond limitations and strive toward greatness.
                            <br/><br/>
                            To pursue academic excellence with discipline reinforces the understanding that success is not accidental. It requires focus, structure, perseverance, and character. And finally, to grow profitably ensures sustainability, enabling the school to continuously improve its facilities, expand its programs, and serve its community with even greater impact.
                            <br/><br/>
                            As members of the Parents Teachers Forum, we recognize that moulding lives and destinies requires collaboration. Education is most effective when parents and teachers work in harmony. When we communicate openly, support consistently, and uphold shared values, our children thrive beyond expectation.
                            <br/><br/>
                            To our dear students, I say this: you are the heartbeat of Ebun Heritage Schools. Within you lies extraordinary potential. Embrace your learning journey. Respect your teachers. Honour your parents. Dream boldly. Work diligently. And always remember that excellence is not a destination — it is a habit.
                            <br/><br/>
                            To our parents, let us continue to support this institution with trust, cooperation, and active participation. Together, we can ensure that our children grow not only in knowledge but also in wisdom and character.
                            <br/><br/>
                            To the management and staff, thank you for sustaining this noble vision. Your leadership, innovation, and dedication continue to elevate the standard of education within our community.
                            <br/><br/>
                            In conclusion, Ebun Heritage Schools is more than an academic institution — it is a community of faith, purpose, discipline, and excellence. It is a place where destinies are shaped, dreams are awakened, and futures are secured.
                            <br/><br/>
                            May we continue to honour God in all that we do.
                            May we remain committed to excellence without compromise.
                            May we raise a generation that will positively transform our society.
                            <br/><br/>
                            Thank you all for your unwavering support and dedication.
                            <br/><br/>
                            God bless Ebun Heritage Schools.
                            God bless our children.
                            And God bless us all.
                            <br/><br/>
                            Thank you.
                        </div>
                    </div>

                </div>

            </div>
        </section>

        <Core/>

        <Footer/>

    </div>
  )
}

export default Chairman